<ion-toolbar
  [class.extra-padding]="extraPadding()"
  [class.no-padding-right]="noPaddingRight()"
  [class.no-padding-left]="noPaddingLeft()"
  [class.pad-left]="padLeft()"
  [class.pad-right]="padRight()"
  [class.no-padding-bottom]="noPaddingBottom()"
>
  <ng-content></ng-content>
</ion-toolbar>
